import { ActionType } from '../../../../core/redux/actionType';
import { makeApiAction, makeRsaaTypes, ApiReducer, makeApiReducer } from '../../../../core/api/rsaa';
import { Endpoints } from '../../../../core/api/endpoints';
import { getLoading, addLoading, addError, noLoadingNoError } from '../../../../core/api/module';
import { SendTo } from '../models';


const KEY_ACTION = ActionType.SendRemindersRequest;
const ACTIONS    = [
  ActionType.SendRemindersRequest,
  ActionType.SendRemindersResponse,
  ActionType.SendRemindersError,
];


type Payload = string;


type Meta = {
  projectId: number;
};


/**
 * Dispatch this action to send reminder emails to raters who have no yet completed the survey for the given project
 * and participant
 *
 * @param projectId - the project to which we wish to invite raters
 * @param participantId - the specific project participant for whom we wish to invite raters
 * @param comment - a custom comment included in the email sent out to invited raters
 * @param to - the list of email addresses to invite (along with the language that should be used for each message)
 */
export const sendRemindersAction = (
  projectId: number,
  participantId: number,
  comment: string,
  to: SendTo[],
) => makeApiAction<Payload, Meta>(
  {
    method:   'POST',
    endpoint: Endpoints.SendReminders,
    headers:  { 'content-type': 'application/json' },
    body:     JSON.stringify({ projectId: projectId, participantId: participantId, comment: comment, to: to }),
    types:    makeRsaaTypes<Payload, Meta>(ACTIONS, { projectId: projectId }),
    bailout:  state => !!getLoading(state, KEY_ACTION, `${projectId}`),
  },
);

const reducer: ApiReducer<Payload, Meta> = (state, action, errorMsg, isLoading, payload) => {
  const metaTag = `${action.meta.projectId}`;

  if (isLoading) {
    return addLoading(state, KEY_ACTION, metaTag);
  }

  if (errorMsg) {
    return addError(state, KEY_ACTION, errorMsg, metaTag);
  }

  return noLoadingNoError(state, KEY_ACTION, metaTag);
};

export const sendRemindersReducer = makeApiReducer<Payload, Meta>(ACTIONS, KEY_ACTION, reducer);
